import React from "react"
import { Box } from "@mui/material"
import {
	Create,
	PasswordInput,
	required,
	SimpleForm,
	TextInput,
	useNotify,
	useRedirect,
	useRefresh,
	useTranslate
} from "react-admin"

import { emailValidator } from "utils"

import { Separator } from "utils/Separator"
import sx from "utils/sx"
import IUserErrors from "./i-user-errors"
import FormGrid from "utils/FormGrid"

/* eslint-disable max-lines-per-function */
const UserCreate = () => {
	const notify = useNotify()
	const refresh = useRefresh()
	const redirect = useRedirect()
	const translate = useTranslate()

	const validateUserCreation = (values: any) => {
		const errors: IUserErrors = {}

		if (values.password !== values.passwordConfirmation) {
			errors.passwordConfirmation = translate("errors.password_confirmation_error")
		}

		if (!emailValidator.test(values.email)) {
			errors.email = translate("errors.invalid_email_address")
		}

		return errors
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onSuccess = (data: any) => {
		notify(
			"resources.users.notifications.create",
			{
				type: "info",
				messageArgs: {
					firstName: data.firstName,
					lastName: data.lastName
				}
			}
		)
		redirect("/users")
		refresh()
	}

	return (
		<Create
			title="resources.users.create"
			mutationOptions={{ onSuccess }}
		>
			<SimpleForm validate={validateUserCreation}>
				<Box sx={sx.prose}>
					<TextInput
						label="resources.users.fields.first_name"
						source="firstName"
						validate={required()}
						fullWidth
					/>
					<TextInput
						label="resources.users.fields.last_name"
						source="lastName"
						validate={required()}
						fullWidth
					/>
					<TextInput
						label="resources.users.fields.email"
						source="email"
						type="email"
						validate={required()}
						fullWidth
					/>
					<Separator />
					<FormGrid>
						<PasswordInput
							label="resources.users.fields.password"
							source="password"
							validate={required()}
							fullWidth
						/>
						<PasswordInput
							label="resources.users.fields.password_confirmation"
							source="passwordConfirmation"
							validate={required()}
							fullWidth
						/>
					</FormGrid>
				</Box>
			</SimpleForm>
		</Create>
	)
}


export default UserCreate
